import { useContext } from 'react';
import DataContext from '../Contexts/DataContext';

export default function useAppState() {
  const { appState } = useContext(DataContext);
  return appState.state;
}
